import { PlayerEvent } from '../PlayerEvent';
import { ReactComponent as ResizeIcon } from '@crazyegginc/hatch/dist/images/icon-resize.svg';

export function ResizeEvent({ timestamp, active, size, ...rest }) {
  return <PlayerEvent icon={ResizeIcon} title="Resize" text={size} timestamp={timestamp} active={active} {...rest} />;
}
